import { GridColDef } from "../../../Unknown/DataGrid";
import {
  AppointmentColumnItemPatientEthnicity,
  AppointmentRowItem,
} from "../types";

export type ColumnPatientEthnicityTranslations = {
  columnPatientEthnicity: string;
  ethnicityOptions: Record<string, string>;
};

const getColumnPatientEthnicity = (params: {
  columnItem: AppointmentColumnItemPatientEthnicity;
  translations: ColumnPatientEthnicityTranslations;
}): GridColDef<AppointmentRowItem, string | null> => {
  const { columnItem, translations } = params;
  const { field } = columnItem;
  return {
    field,
    disableColumnMenu: true,
    flex: 0.8,
    minWidth: 200,
    headerName: translations.columnPatientEthnicity,
    valueGetter: ({ row }) => {
      if (!row.patient?.ethnicity) return null;

      const formattedValue =
        translations.ethnicityOptions[row.patient.ethnicity];

      return formattedValue;
    },
  };
};

export default getColumnPatientEthnicity;
